// import media files
import Avatar1 from 'assets/images/avatar/avatar-1.jpg';
import Avatar2 from 'assets/images/avatar/avatar-2.jpg';
import Avatar3 from 'assets/images/avatar/avatar-3.jpg';
import Avatar4 from 'assets/images/avatar/avatar-4.jpg';
import Avatar6 from 'assets/images/avatar/avatar-6.jpg';
import Avatar7 from 'assets/images/avatar/avatar-7.jpg';
import Avatar18 from 'assets/images/avatar/avatar-18.jpg';
import Avatar12 from 'assets/images/avatar/avatar-12.jpg';
import Avatar13 from 'assets/images/avatar/avatar-13.jpg';
import Avatar14 from 'assets/images/avatar/avatar-14.jpg';
import Avatar17 from 'assets/images/avatar/avatar-17.jpg';
import Avatar15 from 'assets/images/avatar/avatar-15.jpg';

export const StudentsList = [
	{
		id: 1,
		name: 'Reva Yokk',
		image: Avatar1,
		locations: 'Los Angeles, CA',
		enrolled: 6,
		joined: '7 July, 2020',
		payment: 50274,
		progress: 0,
		questionasked: 2
	},
	{
		id: 2,
		name: 'Dianna Smiley',
		image: Avatar2,
		locations: 'United Kingdom',
		enrolled: 3,
		joined: '6 July, 2020',
		payment: 26060,
		progress: 12,
		questionasked: 4
	},
	{
		id: 3,
		name: 'Nia Sikhone',
		image: Avatar17,
		locations: 'United State',
		enrolled: 12,
		joined: '12 June, 2020',
		payment: 8234,
		progress: 14,
		questionasked: 5
	},
	{
		id: 4,
		name: 'Jacob Jones',
		image: Avatar14,
		locations: 'India',
		enrolled: 2,
		joined: '2 July, 2020',
		payment: 8234,
		progress: 33,
		questionasked: 6
	},
	{
		id: 5,
		name: 'Kristin Watson',
		image: Avatar7,
		locations: 'New York',
		enrolled: 10,
		joined: '1 July, 2020',
		payment: 14944,
		progress: 24,
		questionasked: 3
	},
	{
		id: 6,
		name: 'Nia Sikhone',
		image: Avatar17,
		locations: 'Netherland',
		enrolled: 12,
		joined: '12 June, 2020',
		payment: 6845,
		progress: 45,
		questionasked: 8
	},
	{
		id: 7,
		name: 'Rivao Luke',
		image: Avatar17,
		locations: 'New York',
		enrolled: 6,
		joined: '1 July, 2020',
		payment: 8234,
		progress: 100,
		questionasked: 9
	},
	{
		id: 8,
		name: 'Nia Sikhone',
		image: Avatar4,
		locations: 'Netherland',
		enrolled: 12,
		joined: '12 June, 2020',
		payment: 6845,
		progress: 68,
		questionasked: 4
	},
	{
		id: 9,
		name: 'Xiaon Merry',
		image: Avatar6,
		locations: 'Netherland',
		enrolled: 10,
		joined: '8 June, 2020',
		payment: 8234,
		progress: 30,
		questionasked: 7
	},
	{
		id: 10,
		name: 'Sina Ray',
		image: Avatar3,
		locations: 'Africa',
		enrolled: 8,
		joined: '12 June, 2020',
		payment: 3242,
		progress: 12,
		questionasked: 8
	},
	{
		id: 11,
		name: 'Kristin Watson',
		image: Avatar15,
		locations: 'New York',
		enrolled: 13,
		joined: '1 July, 2020',
		payment: 14944,
		progress: 20,
		questionasked: 3
	},
	{
		id: 12,
		name: 'Jacob Jones',
		image: Avatar14,
		locations: 'India',
		enrolled: 2,
		joined: '2 July, 2020',
		payment: 8234,
		progress: 50,
		questionasked: 1
	},
	{
		id: 13,
		name: 'Nia Sikhone',
		image: Avatar17,
		locations: 'Netherland',
		enrolled: 12,
		joined: '12 June, 2020',
		payment: 8234,
		progress: 30,
		questionasked: 0
	},
	{
		id: 14,
		name: 'Sina Ray',
		image: Avatar13,
		locations: 'Africa',
		enrolled: 3,
		joined: '6 July, 2020',
		payment: 26060,
		progress: 60,
		questionasked: 2
	},
	{
		id: 15,
		name: 'Reva Yokk',
		image: Avatar12,
		locations: 'Africa',
		enrolled: 6,
		joined: '7 July, 2020',
		payment: 50274,
		progress: 80,
		questionasked: 3
	},
	{
		id: 16,
		name: 'Xiaon Merry',
		image: Avatar18,
		locations: 'Netherland',
		enrolled: 16,
		joined: '8 June, 2020',
		payment: 8234,
		progress: 90,
		questionasked: 2
	},
	{
		id: 17,
		name: 'Sina Ray',
		image: Avatar3,
		locations: 'Africa',
		enrolled: 8,
		joined: '12 June, 2020',
		payment: 3242,
		progress: 45,
		questionasked: 8
	},
	{
		id: 18,
		name: 'Nia Sikhone',
		image: Avatar4,
		locations: 'Netherland',
		enrolled: 12,
		joined: '12 June, 2020',
		payment: 6845,
		progress: 55,
		questionasked: 2
	},
	{
		id: 19,
		name: 'Nia Sikhone',
		image: Avatar17,
		locations: 'Netherland',
		enrolled: 12,
		joined: '12 June, 2020',
		payment: 6845,
		progress: 45,
		questionasked: 5
	},
	{
		id: 20,
		name: 'Rivao Luke',
		image: Avatar17,
		locations: 'New York',
		enrolled: 6,
		joined: '1 July, 2020',
		payment: 8234,
		progress: 30,
		questionasked: 6
	}
];
export const TestList = [
	{
		id: 1,
		username: 'Reva Yokk',
		email: 'test@gmail.com',
		confirmed: 'true',
		role: 'teacher'
	},    
	{
		id: 2,
		username: 'Dianna Smiley',
		email: 'test1@gmail.com',
		confirmed: 'true',
		role: 'admin'
	},    
	{
		id: 3,
		username: 'Nia Sikhone',
		email: 'test@gmail.com',
		confirmed: 'true',
		role: 'teacher'
	},    
	{
		id: 4,
		username: 'Jacob Jones',
		email: 'test@gmail.com',
		confirmed: 'true',
		role: 'teacher'
	},    
	{
		id: 5,
		username: 'Kristin Watson',
		email: 'test@gmail.com',
		confirmed: 'true',
		role: 'admin'
	},    
	{
		id: 6,
		username: 'Nia Sikhone',
		email: 'test@gmail.com',
		confirmed: 'false',
		role: 'teacher'
	},   
	{
		id: 7,
		username: 'Rivao Luke',
		email: 'test@gmail.com',
		confirmed: 'false',
		role: 'teacher'
	},   
	{
		id: 8,
		username: 'Nia Sikhone',
		email: 'test@gmail.com',
		confirmed: 'true',
		role: 'teacher'
	},    
	{
		id: 9,
		username: 'Xiaon Merry',
		email: 'test@gmail.com',
		confirmed: 'true',
		role: 'teacher'
	},   
	{
		id: 10,
		username: 'Sina Ray',
		email: 'test@gmail.com',
		confirmed: 'true',
		    role: 'teacher'
		
	},
	{
		id: 11,
		username: 'Kristin Watson',
		email: 'test@gmail.com',
		confirmed: 'true',
	    role: 'teacher'
	},
	{
		id: 12,
		username: 'Jacob Jones',
		email: 'test@gmail.com',
		confirmed: 'true',
    role: 'teacher'
	},
	{
		id: 13,
		username: 'Nia Sikhone',
		email: 'test@gmail.com',
		confirmed: 'true',
    role: 'teacher'
	},
	{
		id: 14,
		username: 'Sina Ray',
		email: 'test@gmail.com',
		confirmed: 'true',
	    role: 'teacher'
	},
	{
		id: 15,
		username: 'Reva Yokk',
		email: 'test@gmail.com',
		confirmed: 'true',
		    role: 'teacher'
	},
	{
		id: 16,
		username: 'Xiaon Merry',
		email: 'test@gmail.com',
		confirmed: 'true',
	    role: 'teacher'
	},
	{
		id: 17,
		username: 'Sina Ray',
		email: 'test@gmail.com',
		confirmed: 'true',
		    role: 'teacher'
	},
	{
		id: 18,
		username: 'Nia Sikhone',
		email: 'test@gmail.com',
		confirmed: 'true',
	    role: 'teacher'
	},
	{
		id: 19,
		username: 'Nia Sikhone',
		email: 'test@gmail.com',
		confirmed: 'true',
	    role: 'admin'
	},
	{
		id: 20,
		username: 'Rivao Luke',
		email: 'test@gmail.com',
		confirmed: 'true',
	    role: 'admin'
	}
];
export const StudentsData = [StudentsList];
